var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FullscreenFrontageDialog',{ref:"frontageDialog"},[[_c('CallerIdSettings',{attrs:{"show":true},on:{"goToSettings":_vm.handleSubmit,"cancel":_vm.handleClose}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }